<template>
  <b-card-body>
    <h5>{{ $t('question') }}</h5>
    <div>
      <b-row>
        <b-col>
          <b-input-group>
            <b-form-input readonly v-model="question.value1"></b-form-input>
            <b-form-input readonly disabled style="font-weight: bold;" placeholder=":"></b-form-input>
            <b-form-input readonly v-model="question.value2"></b-form-input>
            <b-form-input readonly disabled style="font-weight: bold;" placeholder="="></b-form-input>
            <b-form-input readonly v-model="question.value3" ></b-form-input>
            <b-form-input readonly disabled style="font-weight: bold;" placeholder=":"></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
    </div>

    <h5 style="margin-top: 25px;">{{ $t('questionalternative') }}</h5>
    <div>
      <b-input-group v-for="(alternative, alternativeIndex) in question.alternatives" :key="alternative.id" :class="alternativeIndex">
        <b-form-input readonly type="text" v-model="alternative.text" />
      </b-input-group>
    </div>
  </b-card-body>
</template>

<script>

export default {
  name: 'display-module-gverb',
  props: {
    question: {}
  }
}
</script>
